import { Quote } from "lucide-react";
import { Reveal, SectionHead } from "./Bits";
import { STORY } from "./content";

const Part = ({ p }) => {
  if (typeof p === "string") return p;
  if (p.hi) return <mark className="bg-rose-100/80 text-rose-700 font-semibold rounded-md px-1 box-decoration-clone">{p.hi}</mark>;
  return <span className="font-display text-xl sm:text-2xl font-black text-rose-600">{p.big}</span>;
};

export function Story() {
  return (
    <section className="relative" data-testid="cs-story" aria-labelledby="cs-story-title">
      <SectionHead id="cs-story-title" eyebrow="Unsere Geschichte" title="❤️ Aus einer Idee wurde etwas Besonderes" />
      <Reveal className="relative mt-6 rounded-[2rem] bg-white/90 backdrop-blur-xl border border-pink-100 shadow-[0_24px_60px_-30px_rgba(225,29,99,.45)] px-6 py-8 sm:px-12 sm:py-12 overflow-hidden">
        <Quote className="absolute -top-2 right-4 w-24 h-24 sm:w-32 sm:h-32 text-rose-100" aria-hidden />
        <span className="absolute left-0 top-10 bottom-10 w-1 rounded-r-full pink-gradient" aria-hidden />
        <div className="relative max-w-2xl space-y-4 text-[15px] sm:text-lg leading-relaxed text-slate-700" data-testid="cs-story-text">
          {STORY.map((parts, i) => <p key={i} className={i === 0 ? "font-display text-xl sm:text-2xl font-extrabold text-slate-900" : ""}>{parts.map((p, j) => <Part key={j} p={p} />)}</p>)}
        </div>
      </Reveal>
    </section>
  );
}
